import React, { useCallback } from 'react'
import { Icon, makeStyles, ButtonBase } from '@material-ui/core'
import { gray } from '../../utils/colors'

const BackButton = ({ onClicked, disabled = false }) => {
	const classes = useStyles()

	const handleOnClicked = useCallback(() => {
		if (onClicked) {
			onClicked()
		}
	}, [onClicked])

	return (
		<ButtonBase disabled={disabled} className={classes.root} disableRipple onClick={handleOnClicked}>
			<Icon
				className={`far fa-arrow-left`}
				style={{
					fontWeight: '400',
					fontSize: '0.9rem',
					color: gray[700],
					width: 20,
					position: 'relative',
					top: '1px'
				}}
			/>
			<span className={classes.text}>Back</span>
		</ButtonBase>
	)
}

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		gap: '.3rem',
		alignItems: 'center'
	},
	text: {
		color: gray[900],
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: '600'
	}
}))

export default BackButton
